import { render, staticRenderFns } from "./RecipeInvoice.vue?vue&type=template&id=fe0a16d4&scoped=true"
import script from "./RecipeInvoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecipeInvoice.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RecipeInvoice.vue?vue&type=style&index=0&id=fe0a16d4&prod&scoped=true&lang=css"
import style1 from "./RecipeInvoice.vue?vue&type=style&index=1&id=fe0a16d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0a16d4",
  null
  
)

export default component.exports